export default "__VITE_ASSET__12e4f46e__"